import React from "react";
import { Linkedin, Mail } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_gland-positioning/artifacts/7ajvflo3_92bd96a0-d046-433e-8e54-c913844612a9.jpeg";

export const Footer = () => {
  return (
    <footer
      data-testid="main-footer"
      className="relative border-t border-[#27272A] bg-[#050505]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 py-14 md:py-20">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <img
                src={LOGO_URL}
                alt="AdjustaGland PRO"
                className="h-12 w-auto"
              />
            </div>
            <p className="mt-5 text-[#A1A1AA] max-w-md leading-relaxed">
              A patent-pending precision tool for commercial and industrial
              electricians. Engineered in the UK. Built on the bench. Refined on
              site.
            </p>

            <div className="mt-7 flex flex-wrap gap-3">
              <span
                data-testid="footer-patent-badge"
                className="font-mono-spec text-[10px] uppercase tracking-[0.22em] px-3 py-1.5 border border-[#27272A] text-[#D4D4D8]"
              >
                ● Patent Pending
              </span>
              <span
                data-testid="footer-trademark-badge"
                className="font-mono-spec text-[10px] uppercase tracking-[0.22em] px-3 py-1.5 border border-[#27272A] text-[#D4D4D8]"
              >
                ● Trademark Pending
              </span>
              <span className="font-mono-spec text-[10px] uppercase tracking-[0.22em] px-3 py-1.5 border border-[#27272A] text-[#D4D4D8]">
                ● UK Engineered
              </span>
            </div>
          </div>

          <div className="lg:col-span-3">
            <div className="label-eyebrow mb-4">Navigate</div>
            <ul className="space-y-3">
              {[
                { l: "The Problem", h: "#problem" },
                { l: "The Solution", h: "#solution" },
                { l: "Features", h: "#features" },
                { l: "Roadmap", h: "#roadmap" },
                { l: "Register Interest", h: "#waitlist" },
              ].map((i) => (
                <li key={i.h}>
                  <a
                    href={i.h}
                    data-testid={`footer-link-${i.l.toLowerCase().replace(/\s+/g, "-")}`}
                    className="text-[#A1A1AA] hover:text-white transition-colors text-sm"
                  >
                    {i.l}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <div className="label-eyebrow mb-4">Contact</div>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  data-testid="footer-email-link"
                  href="mailto:contact@adjustagland.com"
                  className="text-[#A1A1AA] hover:text-white transition-colors inline-flex items-center gap-2"
                >
                  <Mail className="w-4 h-4" /> contact@adjustagland.com
                </a>
              </li>
              <li>
                <a
                  data-testid="footer-linkedin-link"
                  href="#"
                  className="text-[#A1A1AA] hover:text-white transition-colors inline-flex items-center gap-2"
                >
                  <Linkedin className="w-4 h-4" /> LinkedIn
                </a>
              </li>
              <li>
                <a
                  data-testid="footer-privacy-link"
                  href="#"
                  className="text-[#A1A1AA] hover:text-white transition-colors"
                >
                  Privacy Policy
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="divider-line my-10" />

        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <div className="font-mono-spec text-[10px] uppercase tracking-[0.22em] text-[#52525B]">
            © {new Date().getFullYear()} AdjustaGland Ltd · All Rights Reserved
          </div>
          <div className="font-mono-spec text-[10px] uppercase tracking-[0.22em] text-[#52525B]">
            AG-PRO-01 · Build 2025.12 · UK
          </div>
        </div>
      </div>
    </footer>
  );
};
